/* eslint-disable max-len */
export default [
  {
    title: 'Search by Image or Voice',
    description: 'Let our app find it for you',
    ctaUrl: '/c/mobile-app',
    imageUrl: 'https://dam.thdstatic.com/content/production/lDxzraFVV99OCSi36-JNxQ/2I2c_bzxCR4wPWPEXnfqaw/optimizedFile/thumbnail_2020_Capabilities_Image%20Search_%20203165026_NEW[19].png?im=Resize=(400)'
  },
  {
    title: 'Tool & Truck Rental',
    description: 'Rent the tools and equipment you need to get the job done',
    ctaUrl: '/c/tool-and-equipment-rental',
    imageUrl: 'https://dam.thdstatic.com/content/production/L5G0PFqL3TxrSAbwVVeLZw/cnSChzbFVl18UJpdu1jC3w/optimizedFile/TodaysPro_TIFF[48][49]%202.png?im=Resize=(400)'
  },
  {
    title: 'We Deliver Curbside',
    description: 'Order online for convenient store pickup',
    ctaUrl: '/c/curbside_pickup',
    imageUrl: 'https://dam.thdstatic.com/content/production/n1PkhfT5bVyu-Z2FvaqSpg/9Nv50fLqTD-IfqBuBa_xHQ/optimizedFile/6d17d138-1402-41ce-8da8-ae460025223d_088c724b-4aff-45bf-bd08-38ed4916acd6_Prev.png?im=Resize=(400)'
  },
  {
    title: 'Free Delivery',
    description: 'Now over two million items eligible',
    ctaUrl: '/b/Free-Shipping-To-Home/Special-Values/N-5yc1vZ7Z25egxd',
    imageUrl: 'https://dam.thdstatic.com/content/production/bdMnQB1zqf-VP2DVDMBDwg/rsM1OnbnPSGcAwLOOENPfg/optimizedFile/84c5501c-2062-499f-bf80-ae4600250887_39c4885c-182e-46ba-8231-76ff4e60cef7_Prev.png?im=Resize=(400)'
  }
]